var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_644_3165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.58281 18.5484C14.1281 18.5484 18.2562 12.2957 18.2562 6.87501C18.2562 6.69923 18.2523 6.51954 18.2445 6.34376C19.0476 5.76301 19.7406 5.04367 20.291 4.21954C19.5431 4.5523 18.7491 4.76961 17.9359 4.86407C18.7921 4.35089 19.4331 3.54469 19.7402 2.59493C18.9348 3.07226 18.054 3.40897 17.1355 3.59064C16.5167 2.9331 15.6985 2.49773 14.8074 2.35184C13.9163 2.20595 13.002 2.35767 12.2058 2.78354C11.4096 3.20941 10.7758 3.88572 10.4026 4.70789C10.0293 5.53006 9.93721 6.45231 10.1406 7.33204C8.50976 7.2502 6.9143 6.82655 5.45767 6.08854C4.00104 5.35054 2.71576 4.31466 1.68516 3.04806C1.16135 3.95116 1.00106 5.01983 1.23687 6.03687C1.47269 7.05391 2.0869 7.943 2.95469 8.52345C2.30321 8.50277 1.666 8.32736 1.0957 8.01173V8.06251C1.09512 9.01025 1.42276 9.92895 2.02294 10.6624C2.62312 11.3959 3.45879 11.8989 4.38789 12.0859C3.78439 12.2511 3.151 12.2751 2.53672 12.1563C2.79889 12.9713 3.30899 13.6842 3.99582 14.1954C4.68266 14.7066 5.51195 14.9906 6.36797 15.0078C4.9147 16.1494 3.11949 16.7686 1.27148 16.7656C0.943755 16.7651 0.616348 16.745 0.291016 16.7055C2.1684 17.9099 4.35229 18.5496 6.58281 18.5484Z",
    fill: "#c2ccdd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_644_3165"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.291016 0.423828)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.4fdf1d05796e61a4cf10e7f1268c9029.svg";
export { ForwardRef as ReactComponent };